<div class="card card-default">
    <div class="card-header title_size">
        
        <h2 class="card-title">Attendance request Edit</h2>
        <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
            </button>
            <button type="button" class="btn btn-tool" data-card-widget="remove">
                <i class="fas fa-times"></i>
            </button>
        </div>
    </div>

    <div class="card-body">







        <form class="form-data" [formGroup]="creationForm" (ngSubmit)="submit()">
            <div class="d-flex justify-content-end ">
                <button type="submit" class="submit">Submit</button>
            </div>
            <section class="main-page-box">
                <div class="row">
                    <div class="col-12 col-sm-8 col-md-6">
                        <div class="row">
                            <div class="col-12">
                                <label for="employee_name" class="required">Employee</label>
                                <input readonly class="form-control"  name="employee_name" type="text" id="employee_name"
                                    formControlName="employee_name">
                                <div *ngIf="creationForm.get('employee_name')?.invalid && creationForm.get('employee_name')?.touched"
                                    class="text-danger">
                                    Employee is Required
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="requested_for_date" class="required">Requested date</label>
                                <input class="form-control"  name="requested_for_date" type="date" id="requested_for_date"
                                    formControlName="requested_for_date">
                                <div *ngIf="creationForm.get('requested_for_date')?.invalid && creationForm.get('requested_for_date')?.touched"
                                    class="text-danger">
                                    Requested Date is Required
                                </div>
                            </div>
                        </div>
                        </div>
                    <div class="col-12 col-sm-8 col-md-6">
                        <div class="row">
                            <div class="col-12">
                                <label for="status" class="required">Status</label>
                                <select class="form-control"  name="status" type="text" id="status"
                                formControlName="status">
                                    <option *ngFor="let item of Status" [value]="item">{{item}}</option>
                                </select>
                                <div *ngIf="creationForm.get('status')?.invalid && creationForm.get('status')?.touched"
                                    class="text-danger">
                                    Status is Required
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
        </form>
    </div>
</div>